import PromptList from "../../../components/base/messages/PromptList.js";

// Old Goose main.js: <i class="material-icons">bolt</i>, sized at 15px.
// Google Material Icons filled bolt (Apache-2.0):
// https://github.com/google/material-design-icons/blob/master/src/content/bolt/materialicons/24px.svg
const BOLT_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z"/></svg>`;

export default class GoosePromptList extends PromptList {
  render(message) {
    // Old recommendation buttons are text-only; starter buttons keep bolts.
    if (message.data?.source === "recommendations") {
      const wrap = super.render(message);
      wrap?.querySelectorAll(".ws-prompt-icon").forEach((icon) => icon.remove());
      return wrap;
    }
    const items = (message.data?.items || []).map((item) => {
      if (typeof item === "string") return { label: item, value: item, icon: BOLT_ICON };
      if (!item.icon || item.icon === "bolt") return { ...item, icon: BOLT_ICON };
      return item;
    });
    return super.render({ ...message, data: { ...message.data, items } });
  }
}
